//#region src/js/cart-drawer.js
var CartDrawer = class extends HTMLElement {
	isInitialized = false;
	connectedCallback() {
		if (this.isInitialized) return;
		this.isInitialized = true;
		this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
		this.bindOverlayClose();
		this.hydrateRatingSnippetScripts();
		this.setHeaderCartIconAccessibility();
	}
	bindOverlayClose() {
		const overlay = this.querySelector("[data-drawer-overlay]");
		if (!overlay) return;
		overlay.addEventListener("click", this.close.bind(this));
	}
	hydrateRatingSnippetScripts() {
		const ratingContainers = this.querySelectorAll("[data-cart-rating-snippet]");
		if (!ratingContainers.length) return;
		ratingContainers.forEach((container) => {
			container.querySelectorAll("script").forEach((script) => {
				const hydratedScript = document.createElement("script");
				Array.from(script.attributes).forEach((attribute) => {
					hydratedScript.setAttribute(attribute.name, attribute.value);
				});
				hydratedScript.textContent = script.textContent;
				script.parentNode.replaceChild(hydratedScript, script);
			});
		});
	}
	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		if (!cartLink) return;
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}
	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector("[id^=\"Details-\"] summary");
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
		setTimeout(() => {
			this.classList.add("open");
		});
		this.addEventListener("transitionend", () => {
			const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector("[data-cart-empty]") : document.getElementById("CartDrawer");
			const focusElement = this.querySelector("[data-cart-inner]");
			trapFocus(containerToTrapFocusOn, focusElement);
		}, { once: true });
	}
	close() {
		this.classList.remove("open");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}
	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");
		if (cartDrawerNote.nextElementSibling.getAttribute("id")) cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
		});
		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}
	renderContents(parsedState) {
		this.querySelector("[data-cart-inner]").classList.contains("is-empty") && this.querySelector("[data-cart-inner]").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
		});
		setTimeout(() => {
			this.bindOverlayClose();
			this.hydrateRatingSnippetScripts();
			this.open();
		});
	}
	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
	}
	getSectionsToRender() {
		return [{
			id: "cart-drawer",
			selector: "#CartDrawer"
		}, { id: "cart-icon-bubble" }];
	}
	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
	}
	setActiveElement(element) {
		this.activeElement = element;
	}
};
customElements.define("cart-drawer", CartDrawer);
//#endregion
